import { useState } from 'react';

/**
 * T114: motivo do cancelamento — lista pronta + campo livre.
 * O motivo vai junto na requisição e fica gravado no item/comanda e no log de
 * auditoria (T140). Evita o "cancelou e não se sabe por quê".
 */
const MOTIVOS = [
  'Cliente desistiu',
  'Erro de lançamento',
  'Item esgotado',
  'Cortesia',
];

interface Props {
  titulo: string;
  /** T106: resumo do que está sendo cancelado (mesa/cliente/itens/total) */
  resumo?: string[];
  onConfirmar: (motivo: string) => void;
  onCancelar: () => void;
}

export default function ModalMotivoCancelamento({ titulo, resumo, onConfirmar, onCancelar }: Props) {
  const [motivo, setMotivo] = useState(MOTIVOS[0]);
  const [outro, setOutro] = useState('');
  const escolhido = motivo === 'Outro' ? outro.trim() : motivo;

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4">
      <div className="card w-full max-w-sm">
        <h2 className="text-lg font-bold text-gray-100 mb-1">✕ {titulo}</h2>
        <p className="text-sm text-gray-400 mb-3">
          Informe o motivo — ele fica registrado com o seu usuário no histórico.
        </p>

        {resumo && resumo.length > 0 && (
          <ul className="text-xs text-gray-300 space-y-0.5 bg-gray-900/50 rounded-lg p-3 mb-3">
            {resumo.map((linha) => (
              <li key={linha}>{linha}</li>
            ))}
          </ul>
        )}

        <div className="space-y-2">
          {[...MOTIVOS, 'Outro'].map((m) => (
            <label key={m} className="flex items-center gap-2 text-sm text-gray-200">
              <input
                type="radio"
                name="motivo-cancelamento"
                checked={motivo === m}
                onChange={() => setMotivo(m)}
              />
              {m}
            </label>
          ))}
          {motivo === 'Outro' && (
            <input
              className="input-field w-full"
              placeholder="Descreva o motivo"
              value={outro}
              maxLength={200}
              onChange={(e) => setOutro(e.target.value)}
              autoFocus
            />
          )}
        </div>

        <div className="flex gap-2 mt-4">
          <button onClick={onCancelar} className="btn-secondary flex-1">
            Voltar
          </button>
          <button
            onClick={() => onConfirmar(escolhido || 'Outro')}
            disabled={!escolhido}
            className="btn-danger flex-1 disabled:opacity-50"
          >
            Confirmar cancelamento
          </button>
        </div>
      </div>
    </div>
  );
}